import { InputWrapper, InputTitle, StyledInput, IconContainer, InputInnerWrapper } from "./Styles";
import React from "react";

export function Input(
  props: React.InputHTMLAttributes<HTMLInputElement> & {
    Icon?: React.ComponentType;
    title?: string;
    error?: boolean;
    onEnterPress?: () => void;
  }
) {
  const { Icon, title, onEnterPress, error, ...inputProps } = props;

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && onEnterPress) {
      onEnterPress();
    }
  };

  return (
    <InputWrapper>
      <InputTitle $hidden={!title}>{title}</InputTitle>
      <InputInnerWrapper>
        <IconContainer>{Icon && <Icon />}</IconContainer>
        <StyledInput
          {...inputProps}
          $indent={!!Icon}
          $error={error}
          onKeyDown={handleKeyPress}
        />
      </InputInnerWrapper>
    </InputWrapper>
  );
}
